import base from "./base";
import { extendTheme } from "./utils";

export default extendTheme(base, {
    primary: '#bcbcbc',
    primaryDark: '#bcbcbc',

    logoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/wahl-logo.png',
    smallLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/wahl-small.png',
    loadingLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/wahl-logo.png',

    availableProducts: ["FloorCheckGO"],
});